//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  block: 'tocIndex',
  props: ['text','size','numbered','index'],
  data() {
    return {
      pressed: false
    }
  },
  methods: {
    mouseDown() {
      this.pressButton();
    },
    mouseUp() {
      this.unPressButton();
    },
    mouseLeave() {
      this.unPressButton();
    },
    pressButton() {
      this.pressed = true;
    },
    unPressButton() {
      this.pressed = false;
    }
  }
}




// WEBPACK FOOTER //
// ./components/blocks/TocIndex.vue